import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import OtpInput from "../components/OtpInput";
import {
  authTotpVerify,
  establishWordPressSession,
  getAuthValue,
  setAuthFlowStep,
  clearAuthFlow,
  AUTH_STORAGE_KEYS,
} from "../api/authApi";

export default function TotpVerify() {
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const tempToken = getAuthValue(AUTH_STORAGE_KEYS.tempToken);
  const setupToken = getAuthValue(AUTH_STORAGE_KEYS.setupToken);
  const partnerId = getAuthValue(AUTH_STORAGE_KEYS.partnerId);

  useEffect(() => {
    if (!tempToken || !partnerId) {
      navigate("/");
    }
  }, [tempToken, partnerId, navigate]);

  const handleVerifyTotp = async (codeValue) => {
    const token = String(codeValue ?? code).trim();
    setError("");
    if (!token) {
      setError("Authentication code is required");
      return;
    }

    try {
      setLoading(true);
      await authTotpVerify(tempToken, token);
      await establishWordPressSession();
      setAuthFlowStep("authenticated");
      navigate("/licences");
    } catch (e) {
      setError(e.message || "Unable to verify TOTP");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (tempToken) {
      clearAuthFlow();
      navigate("/");
      return;
    }

    if (setupToken) {
      navigate("/2fa/setup");
      return;
    }

    navigate("/");
  };

  return (
    <AuthShell
      title="Two-factor authentication"
      subtitle="Enter your authenticator code."
    >
      <div className="mb-2">
        <OtpInput
          value={code}
          onChange={(next) => {
            if (error) setError("");
            setCode(next);
          }}
          disabled={loading}
        />
      </div>

      {error && (
        <div className="mt-2 text-[12px] text-red-600 text-center">{error}</div>
      )}

      <button
        type="button"
        onClick={() => handleVerifyTotp()}
        disabled={loading}
        className="w-full h-[44px] bg-[#3d3935] border border-[#0f61a1] text-white px-[20px] mt-[15px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 hover:opacity-80 disabled:opacity-60 disabled:cursor-default"
      >
        {loading ? "Signing in..." : "Sign in"}
      </button>

      <button
        type="button"
        onClick={handleBack}
        className="w-full h-[44px] bg-transparent border border-[#d2d2d2] text-[#3d3935] px-[20px] mt-[10px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 hover:opacity-80"
      >
        Back
      </button>
    </AuthShell>
  );
}